import { createSelector } from '@reduxjs/toolkit';

import { IAgentReviewsSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { IState } from '../../store';

export const selectAgentReviews = createSelector(
  (state: IState) => state.offerData.agentReviews,
  agentReviews => agentReviews || ({} as IAgentReviewsSchema),
);
